/**
 * Shared HR Documents upload allowlists (Credentials + Tax Forms).
 * Keep in sync with backend:
 * - forms/credential/constant/credential.ts
 * - forms/tax-and-payroll/constant/tax-and-payroll.ts
 */

/** iPhone Photos default formats */
export const IPHONE_IMAGE_EXTENSIONS = ["heic", "heif"];

export const CREDENTIAL_UPLOAD_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "jpg",
  "jpeg",
  "png",
  ...IPHONE_IMAGE_EXTENSIONS,
];

export const TAX_UPLOAD_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "jpg",
  "jpeg",
  "png",
  ...IPHONE_IMAGE_EXTENSIONS,
];

/** `<input accept>` — include MIME so iOS Photos picker surfaces HEIC. */
export const CREDENTIAL_UPLOAD_ACCEPT =
  ".pdf,.doc,.docx,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif,image/jpeg,image/png,application/pdf";

export const TAX_UPLOAD_ACCEPT =
  ".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif,image/jpeg,image/png,application/pdf";

export const CREDENTIAL_UPLOAD_TYPES_LABEL = "PDF, DOC, JPG, PNG, HEIC";
export const TAX_UPLOAD_TYPES_LABEL = "PDF, JPG, PNG, HEIC";

export function getFileExtension(fileName = "") {
  const parts = String(fileName).split(".");
  if (parts.length < 2) return "";
  return parts.pop()?.toLowerCase() ?? "";
}

export function isAllowedUploadExtension(fileName, allowedExtensions) {
  if (!fileName) return true;
  if (String(fileName).toLowerCase().includes("existing document")) return true;
  const ext = getFileExtension(fileName);
  return Boolean(ext && allowedExtensions.includes(ext));
}

/** PDF / Office / HEIC — browsers usually cannot inline-preview these. */
export function isNonPreviewableDocument(previewUrl, fileName = "") {
  const name = String(fileName).toLowerCase();
  const url = String(previewUrl || "").toLowerCase();
  const ext = getFileExtension(fileName);
  if (ext === "pdf" || ext === "doc" || ext === "docx" || ext === "heic" || ext === "heif") {
    return true;
  }
  if (name.endsWith(".pdf") || url.endsWith(".pdf") || url.startsWith("data:application/pdf")) {
    return true;
  }
  if (
    url.startsWith("data:image/heic") ||
    url.startsWith("data:image/heif") ||
    url.includes("image/heic") ||
    url.includes("image/heif")
  ) {
    return true;
  }
  return false;
}
